module.exports = __webpack_public_path__ + "static/img/bg2-1.4981f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6/bg2-1.jpg
// module id = H+zF
// module chunks = 0